export const carouselItems = [
  {
    id: 1,
    title: '2026暑期档重磅来袭',
    category: '专题策划',
    description: '集结本季最受期待的院线大片与平台独播剧集，从悬疑烧脑到温情治愈，一站式掌握暑期观影风向标，春夜影院陪你度过每一个精彩夏夜。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20with%20golden%20summer%20evening%20light%2C%20movie%20theater%20atmosphere%2C%20vintage%20film%20projector%20with%20soft%20glow%2C%20elegant%20dark%20red%20and%20gold%20color%20palette%2C%20artistic%20composition%2C%20no%20text%2C%20cinematic%20photography%20style&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '暑期热映',
  },
  {
    id: 2,
    title: '豆瓣高分华语剧集盘点',
    category: '剧集推荐',
    description: '精选近一年豆瓣8.0分以上的优质华语剧集，涵盖都市情感、古装权谋、现实题材等多个维度，每一部都值得细细品味，春夜影院蓝光画质呈现每一帧细节。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20drama%20scene%20with%20warm%20ambient%20lighting%2C%20soft%20focus%20on%20traditional%20elements%2C%20cinematic%20composition%20with%20rich%20textures%2C%20dark%20crimson%20and%20amber%20tones%2C%20artistic%20film%20still%20aesthetic%2C%20no%20people&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '口碑佳作',
  },
  {
    id: 3,
    title: '全球综艺热门精选',
    category: '综艺合集',
    description: '从音乐竞演到旅行真人秀，从生活慢综到脱口秀，春夜影院综艺频道收录海内外热门综艺节目，高清画质让每一帧欢笑都清晰动人，随时随地畅享综艺乐趣。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20stage%20lights%20with%20warm%20spotlight%20glow%2C%20variety%20show%20atmosphere%2C%20rich%20golden%20and%20amber%20lighting%2C%20elegant%20entertainment%20venue%20vibe%2C%20cinematic%20photography%2C%20soft%20bokeh%20background%2C%20no%20text&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '综艺热播',
  },
  {
    id: 4,
    title: '经典电影修复重映计划',
    category: '经典回顾',
    description: '那些年我们追过的经典电影，以蓝光画质重新上线。从港片黄金时代的动作经典到华语文艺片的里程碑之作，春夜影院为你保存每一份珍贵的电影记忆。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20aesthetic%20with%20warm%20sepia%20tones%2C%20old%20cinema%20nostalgia%2C%20classic%20movie%20atmosphere%2C%20golden%20hour%20lighting%20through%20film%20grain%2C%20elegant%20composition%20with%20rich%20shadows%2C%20artistic%20photography&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '经典重现',
  },
  {
    id: 5,
    title: '周末片单：编辑精选',
    category: '编辑推荐',
    description: '春夜编辑团队每周精选七部电影，涵盖不同风格与类型，从轻松喜剧到深度纪录片，为你的周末观影时光提供灵感，让好电影成为周末最好的陪伴。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20cinema%20setup%20with%20warm%20ambient%20lighting%2C%20soft%20blanket%20and%20popcorn%2C%20evening%20mood%2C%20golden%20warm%20tones%2C%20cinematic%20atmosphere%2C%20comfortable%20viewing%20experience%2C%20artistic%20composition%2C%20no%20text&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '编辑精选',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '电影迷小陈',
    rating: 5,
    date: '2026-07-28',
    content: '春夜影院的画质真的太棒了！之前在其他平台看总是卡顿，这边蓝光画质完全不缓冲，观影体验提升了不止一个档次。最近补了好多老电影，清晰度感人。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20with%20warm%20lighting%2C%20simple%20background%2C%20professional%20headshot%20style%2C%20neutral%20expression%2C%20soft%20shadows%2C%20clean%20composition&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    id: 2,
    name: '剧荒拯救者',
    rating: 5,
    date: '2026-07-26',
    content: '片库真的太大了，几乎想看的电影电视剧都能找到。最近追的那部古装剧，更新速度比别的平台还快，画质还是蓝光的，太良心了。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20with%20soft%20natural%20light%2C%20simple%20warm%20background%2C%20casual%20friendly%20look%2C%20clean%20headshot%20style%2C%20gentle%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    id: 3,
    name: '深夜观影人',
    rating: 4,
    date: '2026-07-25',
    content: '每天晚上睡前都会来春夜影院刷一两集剧，流畅不卡顿这点真的好评。页面也没有乱七八糟的广告弹窗，观影界面干干净净的，沉浸感很强。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20with%20evening%20warm%20lighting%2C%20simple%20dark%20background%2C%20thoughtful%20expression%2C%20clean%20headshot%20composition%2C%20soft%20moody%20tone&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
  {
    id: 4,
    name: '综艺达人阿May',
    rating: 5,
    date: '2026-07-23',
    content: '综艺更新速度绝了！国外的热门综艺这边基本同步更新，而且都有中文字幕。周末窝在家用投影仪投屏看，蓝光画质在大屏幕上效果炸裂。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20with%20bright%20natural%20light%2C%20simple%20light%20background%2C%20cheerful%20friendly%20look%2C%20clean%20headshot%20style%2C%20warm%20smile&width=80&height=80&seq=avatar-04&orientation=squarish',
  },
  {
    id: 5,
    name: '影视老饕',
    rating: 5,
    date: '2026-07-21',
    content: '作为一个看了二十多年电影的老影迷，春夜影院的片库深度让我惊喜。很多冷门文艺片和独立电影都能找到，而且画质很好，真正做到了免费高清在线看。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20with%20warm%20studio%20lighting%2C%20simple%20background%2C%20mature%20thoughtful%20look%2C%20clean%20headshot%20style%2C%20calm%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
  },
];

export const appEntryItem = {
  title: '春夜影院 · 移动观影',
  subtitle: '随时随地，高清相伴',
  description: '春夜影院移动端完美适配手机与平板，支持 Chrome、Safari 等主流浏览器直接访问。无需下载安装，打开即看，蓝光画质在移动端同样流畅呈现。支持投屏功能，大屏观影更沉浸。通勤路上、午休间隙，随时随地享受高清影视内容。',
  features: ['免安装即开即看', '移动端蓝光画质', '支持投屏大屏观影', '流量优化流畅不卡顿'],
  icon: 'ri-smartphone-line',
};

export const featureItems = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '蓝光画质',
    description: '全站内容支持蓝光高清画质播放，每一帧画面都清晰细腻，色彩还原真实自然，带来影院级视觉享受。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    description: '自研播放引擎搭配全球CDN加速节点，确保视频秒开不卡顿，即使在网络高峰期也能获得丝滑流畅的观影体验。',
  },
  {
    id: 3,
    icon: 'ri-film-line',
    title: '海量片库',
    description: '收录数万部电影、电视剧、综艺及动漫作品，涵盖全球热门内容与经典佳作，每天都有新内容上线，片库持续扩充中。',
  },
  {
    id: 4,
    icon: 'ri-device-line',
    title: '多端兼容',
    description: '电脑、平板、手机全终端完美适配，同一账号多设备同步观看记录，随时随地无缝切换，追剧不间断。',
  },
  {
    id: 5,
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    description: '同步各大平台最新上线内容，热门剧集播出后第一时间更新，确保你不会错过任何精彩瞬间，追剧快人一步。',
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '长安十二时辰', category: '古装悬疑', heat: '9.8', trend: 'up' },
  { id: 2, rank: 2, title: '流浪地球3', category: '科幻冒险', heat: '9.7', trend: 'up' },
  { id: 3, rank: 3, title: '繁花', category: '都市剧情', heat: '9.6', trend: 'stable' },
  { id: 4, rank: 4, title: '隐秘的角落', category: '悬疑犯罪', heat: '9.5', trend: 'up' },
  { id: 5, rank: 5, title: '乘风破浪的姐姐', category: '音乐综艺', heat: '9.4', trend: 'down' },
  { id: 6, rank: 6, title: '三体', category: '科幻巨制', heat: '9.3', trend: 'stable' },
  { id: 7, rank: 7, title: '漫长的季节', category: '现实题材', heat: '9.2', trend: 'up' },
];

export const faqItems = [
  {
    id: 1,
    question: '春夜影院真的完全免费吗？需要注册会员吗？',
    answer: '春夜影院对所有用户完全免费开放，无需注册或登录即可观看全部内容。我们致力于提供免费高清在线看服务，不设置任何付费墙或会员门槛，所有电影、电视剧、综艺和动漫内容均可直接播放。',
  },
  {
    id: 2,
    question: '播放画质怎么样？支持蓝光画质吗？',
    answer: '春夜影院全站内容支持蓝光画质播放，默认提供高清画质，您也可以在播放器中手动切换至蓝光画质模式。我们采用先进的视频编码技术和CDN加速，确保蓝光画质也能流畅不缓冲地播放。',
  },
  {
    id: 3,
    question: '电视剧和综艺的更新速度快吗？',
    answer: '非常快！我们与各大内容渠道保持同步，热门剧集和综艺节目播出后第一时间更新上线。通常国内剧集播出后数小时内即可在春夜影院观看，海外综艺也会在24小时内同步更新并配有中文字幕。',
  },
  {
    id: 4,
    question: '手机上可以看吗？支不支持投屏？',
    answer: '完全可以！春夜影院完美适配手机、平板等移动设备，通过浏览器直接访问即可观看，无需下载任何App。同时支持ChromeCast和AirPlay投屏功能，您可以将内容投射到电视或投影仪上享受大屏观影体验。',
  },
  {
    id: 5,
    question: '片库内容全吗？能找到老电影和冷门作品吗？',
    answer: '春夜影院片库涵盖数万部影视作品，从最新的院线大片到经典的七八十年代老电影，从热门商业片到小众独立文艺片，我们都尽可能收录。如果您有特别想看的作品，也可以通过联系我们页面提交片源建议。',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《流浪地球3》幕后制作特辑',
    category: '电影花絮',
    duration: '15:42',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20atmosphere%20with%20warm%20golden%20nebula%20lighting%2C%20space%20exploration%20theme%2C%20dramatic%20composition%2C%20rich%20dark%20and%20amber%20tones%2C%20film%20production%20aesthetic%2C%20no%20text&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《繁花》经典场景深度解析',
    category: '剧集解读',
    duration: '22:08',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Shanghai%20nostalgia%20scene%20with%20warm%20golden%20evening%20light%2C%20vintage%20cityscape%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20crimson%20tones%2C%20artistic%20film%20aesthetic&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '年度综艺名场面混剪',
    category: '综艺精选',
    duration: '08:35',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20stage%20performance%20with%20colorful%20warm%20spotlights%2C%20variety%20show%20energy%2C%20rich%20golden%20and%20amber%20lighting%2C%20cinematic%20composition%2C%20entertainment%20atmosphere%2C%20no%20people&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '经典港片动作场面回顾',
    category: '经典重温',
    duration: '18:20',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20cinema%20aesthetic%20with%20warm%20sepia%20tones%2C%20classic%20film%20atmosphere%2C%20dramatic%20lighting%2C%20rich%20shadows%20and%20golden%20highlights%2C%20nostalgic%20movie%20style%2C%20artistic%20composition&width=640&height=360&seq=media-04&orientation=landscape',
  },
];

export const updateItems = [
  { id: 1, date: '2026-08-01', title: '《三体·黑暗森林》首支预告片正式发布', description: '备受期待的科幻巨制续作预告片上线，视觉效果全面升级。' },
  { id: 2, date: '2026-07-31', title: '暑期档票房冠军电影独家上线春夜影院', description: '今年暑期档票房冠军影片已登陆平台，蓝光画质独家呈现。' },
  { id: 3, date: '2026-07-30', title: '海外热门综艺新一季同步更新', description: '多档海外热门综艺最新季已上线，中文翻译同步推出。' },
  { id: 4, date: '2026-07-28', title: '播放器升级：新增智能画质调节功能', description: '根据网络状况自动匹配最优画质，确保观影不卡顿。' },
  { id: 5, date: '2026-07-26', title: '经典修复：50部港片蓝光重制上线', description: '精选50部经典港片以蓝光画质重新制作，画质全面提升。' },
  { id: 6, date: '2026-07-24', title: '移动端体验优化，加载速度提升40%', description: '全面优化移动端播放体验，流量消耗降低，加载更快。' },
  { id: 7, date: '2026-07-22', title: '新剧《长安十二时辰》全集上线', description: '年度口碑古装悬疑剧全集一次性上线，蓝光画质畅爽追剧。' },
  { id: 8, date: '2026-07-20', title: '纪录片频道全新改版上线', description: '新增自然、历史、科技三大板块纪录片，高清画质沉浸观看。' },
  { id: 9, date: '2026-07-18', title: '春夜影院用户突破千万', description: '感谢每一位观众的支持，我们将继续提供优质的免费观影体验。' },
];

export const topicItems = [
  { id: 1, name: '暑期档', heat: '128万' },
  { id: 2, name: '科幻大片', heat: '96万' },
  { id: 3, name: '古装剧', heat: '87万' },
  { id: 4, name: '悬疑推理', heat: '74万' },
  { id: 5, name: '综艺热播', heat: '69万' },
  { id: 6, name: '都市情感', heat: '63万' },
  { id: 7, name: '蓝光画质', heat: '58万' },
  { id: 8, name: '经典港片', heat: '52万' },
  { id: 9, name: '国产动画', heat: '46万' },
  { id: 10, name: '纪录片', heat: '41万' },
];

export const indexItems = [
  { id: 1, icon: 'ri-movie-2-line', title: '最新电影', count: '1,280部', description: '院线大片、独立佳作、全球热门' },
  { id: 2, icon: 'ri-tv-2-line', title: '电视剧大全', count: '860部', description: '国剧、韩剧、美剧、日剧全覆盖' },
  { id: 3, icon: 'ri-live-line', title: '综艺节目', count: '520档', description: '音乐、旅行、脱口秀、真人秀' },
  { id: 4, icon: 'ri-ancient-gate-line', title: '动漫频道', count: '730部', description: '热血、治愈、国漫、日漫精选' },
  { id: 5, icon: 'ri-slideshow-3-line', title: '纪录片', count: '360部', description: '自然、历史、科技、人文探索' },
  { id: 6, icon: 'ri-vip-crown-line', title: '高分必看', count: '210部', description: '豆瓣8.0+口碑佳作精选合集' },
  { id: 7, icon: 'ri-fire-line', title: '热门排行', count: '实时更新', description: '观众最爱的热播内容实时榜单' },
];

export const cardItems = [
  {
    id: 1,
    title: '如何选择今晚的电影？',
    description: '根据你的心情和可用的观影时间，从类型、时长、评分三个维度帮你快速锁定最适合今晚的电影，告别选择困难症。',
    tag: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20evening%20home%20cinema%20scene%20with%20warm%20ambient%20lighting%2C%20movie%20selection%20on%20screen%2C%20comfortable%20living%20room%20atmosphere%2C%20golden%20warm%20tones%2C%20cinematic%20photography%20style%2C%20no%20people&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '蓝光 vs 高清：画质对比',
    description: '从分辨率、色彩深度、码率三个方面详细对比蓝光画质与普通高清的区别，帮你理解为什么蓝光观影体验更沉浸。',
    tag: '技术科普',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20color%20grading%20comparison%20scene%20with%20warm%20rich%20colors%2C%20film%20texture%20and%20detail%2C%20professional%20video%20quality%20aesthetic%2C%20golden%20and%20crimson%20tones%2C%20artistic%20composition%2C%20no%20text&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '周末追剧马拉松指南',
    description: '精选五部口碑爆款剧集，从古装权谋到现代悬疑，每部都控制在24集以内，一个周末刚好追完一部，节奏紧凑无尿点。',
    tag: '追剧攻略',
    image: 'https://readdy.ai/api/search-image?query=Relaxing%20weekend%20binge%20watching%20setup%20with%20warm%20lighting%2C%20comfortable%20couch%20and%20snacks%2C%20cozy%20atmosphere%2C%20golden%20afternoon%20light%2C%20cinematic%20home%20theater%20vibe%2C%20no%20people&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '不可错过的纪录片清单',
    description: '从自然奇观到人类文明，这十部纪录片用蓝光画质呈现世界之美。每一帧都堪比电影级画面，拓展你的认知边界。',
    tag: '内容推荐',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20scene%20with%20warm%20golden%20sunlight%2C%20landscape%20cinematography%2C%20rich%20natural%20colors%2C%20cinematic%20composition%2C%20epic%20scale%2C%20artistic%20photography%2C%20no%20people&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '暑期亲子观影推荐',
    description: '精心挑选适合全家一起观看的电影和动画，兼顾趣味性与教育意义，让亲子时光更加温馨有意义，全部支持蓝光画质播放。',
    tag: '亲子时光',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20living%20room%20with%20soft%20evening%20light%2C%20cozy%20cinema%20atmosphere%2C%20colorful%20decorations%2C%20golden%20warm%20tones%2C%20comfortable%20family%20setting%2C%20cinematic%20photography%2C%20no%20people&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '新用户观影入门指南',
    description: '第一次来春夜影院？这份指南帮你快速了解搜索、收藏、画质切换、字幕设置等实用功能，五分钟成为观影达人。',
    tag: '使用教程',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20digital%20interface%20with%20warm%20ambient%20lighting%2C%20clean%20design%20aesthetic%2C%20cinematic%20dark%20mode%2C%20golden%20accents%2C%20elegant%20tech%20atmosphere%2C%20artistic%20composition%2C%20no%20text&width=600&height=400&seq=card-06&orientation=landscape',
  },
];

export const contactItem = {
  title: '联系我们',
  subtitle: '意见反馈 · 片源建议 · 合作咨询',
  description: '春夜影院始终倾听观众的声音。如果您在使用过程中遇到任何问题，或有想看的影片建议，或希望与我们展开商务合作，欢迎通过以下方式联系我们。我们会在第一时间回复您的反馈。',
  email: 'contact@chunye.tv',
  wechat: 'ChunYeCinema',
  qq: '1234567890',
};

export const aboutItem = {
  title: '关于春夜影院',
  description: '春夜影院是一个致力于提供免费高清在线看服务的影视内容平台，涵盖最新电影、电视剧大全、综艺节目和动漫等丰富内容。我们秉持"让好电影触手可及"的理念，通过蓝光画质和流畅不缓冲的播放技术，为每一位观众打造沉浸式的观影体验。无论你是在寻找春夜影院最新电影全集，还是想回顾经典电视剧大全，春夜影院都是你值得信赖的观影伙伴。在每一个宁静的春夜，我们陪你一起看好电影。',
};